// packages
const { h, Component } = require("preact");
import { formatNumberAnnotation, formatNumberWithCommas } from '../../utils/utils';

// components

// internal

class Annotation extends Component {
  constructor() {
    super();

    this.state = {}
  }

  render() {
    return (
      <div class={`bar-cell annotation${this.props.county == "HARRIS" | this.props.category == "red" ? "-first" : ""}`}>
        <span>{this.props.regVoters > 1000000 ? formatNumberAnnotation(this.props.regVoters) : formatNumberWithCommas(this.props.regVoters)}</span>{this.props.county == "HARRIS" | this.props.category == "red" ? "registered voters" : ""}
      </div>
    )
  }
}

export default Annotation;